import React, { useState } from "react";
import { useContext } from "../../../context";
import { CustomerNotes } from "./shared/CustomerNotes";
import { not } from "../../../../../../../../../utilities/fp";
import { Header } from "./shared/Header";
import { uiNotification } from "../../../../../../../../../services/UINotificationService";
import { useCheckin } from "../../../hooks/useCheckin";

function ModalCheckin() {
  const {
    modals: {
      checkin: { isOpen, close },
    },
  } = useContext();

  const checkin = useCheckin();

  const [selectedNotes, setSelectedNotes] = useState([]);
  const [sendToProvider, setSendToProvider] = useState(false);
  const [customerNote, setCustomerNote] = useState("");
  const [room, setRoom] = useState("");

  const onClose = () => {
    close();
    setSelectedNotes([]);
    setSendToProvider(false);
    setCustomerNote("");
    setRoom("");
  };

  const onSubmit = async () => {
    if (!room.trim()) {
      uiNotification.error("Room is required.");
      return Promise.reject("Room is required.");
    }
    return checkin
      .initiate({
        room,
        notes: selectedNotes,
        customerNewNote: customerNote,
        sendToProvider,
      })
      .then(onClose);
  };

  return (
    <>
      {isOpen && (
        <div className="blackOverlay">
          <div className="vert-middle">
            <div className="loyaltyMembership start-program-main">
              <Header onClose={onClose} />
              <div className="newPopupContent">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="simpleField">
                      <div className="simpleLabel">
                        ROOM
                        <span className="required">*</span>
                      </div>
                      <input
                        className="simpleInput"
                        type="text"
                        name="room"
                        value={room}
                        autoComplete="off"
                        onChange={(e) => setRoom(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="simpleField">
                      <div className="simpleLabel">ADD CUSTOMER NOTE</div>
                      <input
                        className="simpleInput"
                        type="text"
                        name="customer_note"
                        value={customerNote}
                        autoComplete="off"
                        onChange={(e) => setCustomerNote(e.target.value)}
                      />
                    </div>
                  </div>
                  <p className="p-text col-xs-12">
                    <input
                      type="checkbox"
                      className="new-check"
                      value={sendToProvider}
                      name="send_to_provider"
                      checked={sendToProvider ? "checked" : false}
                      autoComplete="off"
                      onChange={() => setSendToProvider(not)}
                    />
                    Send this new note to provider
                  </p>
                </div>
                <CustomerNotes
                  value={selectedNotes}
                  setValue={setSelectedNotes}
                />
              </div>
              <div>
                <button
                  className="new-blue-btn pull-right"
                  onClick={onSubmit}
                  disabled={checkin.isCheckingIn}
                >
                  {checkin.isCheckingIn
                    ? "Checking in..."
                    : "Complete Check In"}
                </button>
                <button
                  className="new-white-btn pull-right no-width"
                  onClick={onClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

ModalCheckin.useHandler = function () {
  const [state, setState] = useState(null);

  return {
    state,
    isOpen: Boolean(state),
    open: () => {
      setState({});
    },
    close: () => {
      setState(null);
    },
  };
};

export { ModalCheckin };
